import { Directive, AfterViewChecked } from '@angular/core';
declare var $: any; // JQuery

/**
 * AUDITORÍA JQUERY (Fase 6 — plan layout/mejoras-ux-2026-08, ago-2026):
 * Esta directiva es el ÚNICO consumidor real de jQuery en el proyecto.
 * Implementa el toggle funcional (expandir/colapsar con animación
 * slideUp/slideDown) de los submenús del sidenav en modo desktop
 * expandido — NO es decorativo, sin esto el menú no se despliega.
 *
 * jQuery en package.json/angular.json (~280KB sin minificar) se declara
 * como devDependency de terceros (chartist, domino, ua-parser-js) pero
 * ninguno de ellos lo usa como dependencia de runtime real; el único uso
 * en código propio es este archivo.
 *
 * Para eliminar jQuery del bundle habría que reescribir esta lógica con
 * Angular puro ((click) bindings + [class.ant-menu-submenu-open] +
 * animaciones CSS o @angular/animations). Es un cambio funcional que
 * toca la navegación del sidenav — se deja pendiente para el plan de
 * upgrade de Angular, no se aborda en este plan de limpieza de layout.
 */
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[sideNav]'
})
export class SideNavDirective implements AfterViewChecked {

    
    ngAfterViewChecked() {
        $('.side-nav .side-nav-menu:not(.ant-menu-inline-collapsed) li a').click(function(event) {            
            if ($(this).parent().hasClass('ant-menu-submenu-open')) {

                $(this).parent().children('.dropdown-menu').slideUp(200, function() {
                    $(this).parent().removeClass('ant-menu-submenu-open');
                });

            } else {
                $(this).parent().parent().children('li.ant-menu-submenu-open').children('.dropdown-menu').slideUp(100);
                $(this).parent().parent().children('li.ant-menu-submenu-open').children('a').removeClass('ant-menu-submenu-open');
                $(this).parent().parent().children('li.ant-menu-submenu-open').removeClass('ant-menu-submenu-open');
                $(this).parent().children('.dropdown-menu').slideDown(100, function() {
                    $(this).parent().addClass('ant-menu-submenu-open');
                });
            }
        });

        $('.ant-menu-item').on('click', function(e){            
            $('.ant-menu-item-active').removeClass('ant-menu-item-active');
            $(this).addClass('ant-menu-item-active');
        });
        
    }
}